import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";

const AnalyzeButtonLoading = () => (
    <>
        <Skeleton className="h-10 w-24" />
        <Skeleton className="h-10 w-32" />
    </>
);

export default function AnalyzeButton({
    handleAnalyze,
    isAnalyzing,
    file,
    selectedTypes,
    isDualAnalysis,
    isLoading
}) {
    if (isLoading) {
        return <AnalyzeButtonLoading />;
    }

    const isDisabled = !file || isAnalyzing || !selectedTypes.primary || (isDualAnalysis && !selectedTypes.secondary);

    return (
        <div className="flex gap-3">
            <Button
                variant="outline"
                onClick={() => window.location.reload()}
                disabled={isAnalyzing}
            >
                Clear
            </Button>
            {isAnalyzing ? (
                <>
                    <Button
                        disabled={true}
                        className="bg-blue-600"
                    >
                        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                        Analyzing
                    </Button>
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="secondary"
                                    className="bg-green-600 hover:bg-green-700 text-white"
                                    onClick={() => window.location.reload()}
                                >
                                    New Analysis
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Start a new analysis while the current one processes</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </>
            ) : (
                <Button
                    className="bg-blue-600 hover:bg-blue-700"
                    onClick={handleAnalyze}
                    disabled={isDisabled}
                >
                    Start Analysis
                </Button>
            )}
        </div>
    );
}